import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, isRef as _isRef, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/jianyan_ic_saoma@2x.png'
import _imports_1 from '@/assets/icon/btn_upload@2x.png'
import _imports_2 from '@/assets/icon/ic_delete@2x.png'
import _imports_3 from '@/assets/icon/ic_play@2x.png'


const _withScopeId = n => (_pushScopeId("data-v-d14a59f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box1" }
const _hoisted_2 = { class: "box_list" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_list_item_left" }, [
  /*#__PURE__*/_createElementVNode("span", null, "检验设备"),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1))
const _hoisted_4 = { class: "box_list_item_right" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "boxs" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", null, "扫描设备")
], -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_list_item_left" }, [
  /*#__PURE__*/_createElementVNode("span", null, "巡检时间"),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1))
const _hoisted_9 = { class: "box_list_item_right" }
const _hoisted_10 = { class: "black" }
const _hoisted_11 = { class: "box_list1" }
const _hoisted_12 = { class: "box_list1_item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_list1_item_left" }, [
  /*#__PURE__*/_createElementVNode("span", null, "设备状态"),
  /*#__PURE__*/_createElementVNode("span", null, "*")
], -1))
const _hoisted_14 = { class: "box_list1_item_right" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "box_list1_club" }
const _hoisted_17 = { class: "box_list1_club_label" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("巡检现场照片")
const _hoisted_19 = { class: "box_list1_club_list" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "type" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "type_img",
    src: _imports_1,
    alt: ""
  })
], -1))
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = {
  key: 0,
  class: "play",
  src: _imports_3
}
const _hoisted_25 = { class: "type" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_list1_club_list_item1" }, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_list1_club_list_item1" }, null, -1))
const _hoisted_30 = { class: "box_list2" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box_list2_label" }, "备注", -1))
const _hoisted_32 = { class: "box_footer" }
const _hoisted_33 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_34 = [
  _hoisted_33
]

import { ref, watch, onMounted, reactive } from 'vue'
    import { setTime, judgmentType, sizeTostr } from '@/utils/utils'
    import { queryListByCode, uploadFiles } from '@/apis/index'
    import { saveBean, getDeviceByCondition, getsbInfo } from '@/apis/QualityAPI'
    import { getBarcodeContent } from '@/apis/WorkOrderAPI'
    import { QRCodeType } from '@/enum'
    import { Toast } from 'vant'
    import { useRouter } from 'vue-router'
    import vPreview from '@/components/common/Preview.vue'

    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter()

    let upload: any = ref(null)

    // 打开大图默认展示下标
    let index = ref<number>(0)

    let isOpen = ref<boolean>(false)

    // 弹框显示隐藏
    let show = ref<boolean>(false)

    // 文件上传路劲
    let path = ref<string>('')

    // 弹框显示隐藏时间选择器
    let showTime = ref<boolean>(false)

    // 扫一扫显示/隐藏
    let openCodea = ref<boolean>(false)

    // 搜索值
    let value = ref<string>('')

    // 筛选数据
    let data = ref<Array<any>>([])

    // 设备列表
    let columns = ref<Array<object>>([])

    // 设备状态
    let status = ref([
        { name: '正常', active: true, id: '0' },
        { name: '异常', active: false, id: '1' }
    ])

    const currentDate = ref(new Date());

    const minDate = new Date(2020, 0, 1)

    const maxDate = new Date(2025, 10, 1)

    // 提交数据
    const form = reactive<{ equipmentId: string, equipmentName: string, time: string, status: string, files: Array<object>, remarks: string }>({
        equipmentId: '',    // 设备id
        equipmentName: '',  //设备名称
        time: '',   // 巡检时间
        status: '0',     // 设备状态
        files: [],      // 巡检图片/视频
        remarks: ''     // 备注
    })

    // 提交检验
    const submit = () => {
        if (!form.equipmentId) return Toast.fail({ message: '设备不能为空' })
        if (!form.time) return Toast.fail({ message: '时间不能为空' })
        if (!form.status) return Toast.fail({ message: '状态不能为空' })
        if (form.status == '1') {
            if (form.files.length === 0) return Toast.fail({ message: '现场照片不能为空' })
        }
        saveBean({
            checkDate: form.time,
            content: form.remarks,
            deviceId: form.equipmentId,
            status: form.status,
            multiFilesSaveBeans: form.files
        }).then(res => {
            if (res.code === 200) {
                Toast.success({ message: "提交成功", duration: 2000, forbidClick: true })
                setTimeout(() => {
                    router.go(-1)
                }, 2000)
            }
        })
    }

    // 查看大图/视频
    const seeBigFile = (i: number): void => {
        index.value = i
        isOpen.value = true
    }

    // 删除指定文件
    const dele = (i: number): void => {
        form.files.splice(i, 1)
    }

    // 获取当前用户下所有设备
    const getSB = () => {
        getDeviceByCondition({})
            .then(res => {
                if (res.code === 200 && res.data && res.data.length > 0) {
                    columns.value = []
                    res.data.forEach((item: any) => {
                        columns.value.push({ text: item.name, id: item.id })
                    })
                }
            })
    }

    // 打开视频/图片大图预览
    const openPreview = () => {
        isOpen.value = true
    }

    // 关闭查看大图/视频组件
    const close = () => {
        isOpen.value = false
    }

    // 获取文件
    const upFile = async (e: any) => {
        if (form.files.length + e.target.files.length > 9) {
            Toast.fail({ message: '最多只能上传9个图片/视频' })
            upload.value.value = ''
            return
        }
        for (let i = 0; i < e.target.files.length; i++) {
            let type: string = e.target.files[i].type
            let index = type.indexOf('/')
            let data = type.substring(index + 1, type.length)
            const format = new FormData()
            format.append('file', e.target.files[i])
            format.append('folder', path.value)
            let res = await uploadFiles(format)
            if (res.code === 200) {
                form.files.push({
                    fileUrl: res.data.imgaddr,
                    filename: res.data.imgname,
                    filesize: e.target.files[i].size,
                    type: judgmentType(data.toLowerCase()) ? 0 : 1,
                    url: res.data.url
                })
            }
        }
        upload.value.value = ''
    }

    // 点击上传
    const uploadFile = () => {
        upload.value.click()
    }

    // 关闭时间选择器
    const closeTime = () => {
        showTime.value = false
    }

    // 确认选择日期
    const queding = (val: any): void => {
        form.time = setTime(val, '-')
        showTime.value = false
    }

    // 打开时间选择器
    const openTime = () => {
        showTime.value = true
    }

    // 扫码回调
    const onDecodea = (data: string[]): void => {
        openCodea.value = false
        getBarcodeContent({
            barcode: data[0]
        }).then(res => {
            if (res.code === 200) {
                if (res.data.barcodeType === QRCodeType.SB) {
                    getsbInfo(res.data.id)
                        .then(res => {
                            if (res.code === 200) {
                                form.equipmentId = res.data.id
                                form.equipmentName = res.data.name
                            }
                        })
                } else {
                    Toast.fail({ message: '请扫描正确的设备码' })
                }
            }
        })
    }

    // 打开扫一扫
    const openCode = (): void => {
        openCodea.value = true
    }

    // 关闭扫一扫
    const closePopupa = (): void => {
        openCodea.value = false
    }

    // 模糊搜索
    const changeValue = (val: any): void => {
        data.value = []
        let { _value } = val.target
        if (!_value) return
        columns.value.forEach((item: any) => {
            if (item.text.indexOf(_value) !== -1) {
                data.value.push(item)
            }
        })
    }

    // 关闭弹框
    const onCancel = (): void => {
        show.value = false
    }

    // 确认选择设备
    const onConfirm = (value: any): void => {
        form.equipmentId = value.id
        form.equipmentName = value.text
        show.value = false
    }

    // 打开设备弹框
    const open = (): void => {
        show.value = true
    }

    // 改变状态
    const changeItem = (i: number, id: string): void => {
        status.value.forEach((item: any, index: number) => {
            item.active = index === i;
        })
        form.status = id
    }

    // 监听设备弹框关闭
    watch(() => show.value, (news, old) => {
        if (!news) {
            value.value = ''
            data.value = []
        }
    })

    // 获取字典纸
    const getqueryListByCode = () => {
        queryListByCode({
            dicCode: 'FOLDER',
            label: 'DEVICE_CHECK'
        }).then(res => {
            if (res.code === 200) {
                path.value = res.data[0].code
            }
        })
    }

    onMounted(() => {
        getSB()
        getqueryListByCode()
        form.time = setTime(new Date(), '-')
    })

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_v_ScanCode = _resolveComponent("v-ScanCode")!
  const _directive_preventReClick = _resolveDirective("preventReClick")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "box_list_item",
        onClick: open
      }, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", {
            style: _normalizeStyle(_unref(form).equipmentName ? 'color: #000' : '')
          }, _toDisplayString(_unref(form).equipmentName ? _unref(form).equipmentName : '点击选择巡检设备'), 5),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "18",
            color: "#999999"
          })
        ])
      ]),
      _createElementVNode("div", {
        class: "box_list_code",
        onClick: _withModifiers(openCode, ["stop"])
      }, _hoisted_7, 8, _hoisted_5),
      _createElementVNode("div", {
        class: "box_list_item",
        onClick: openTime
      }, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_unref(form).time), 1),
          _createVNode(_component_van_icon, {
            name: "arrow",
            size: "18",
            color: "#999999"
          })
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _createElementVNode("div", _hoisted_14, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(status), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["box_list1_item_right_item", {'active': item.active}]),
              key: index,
              onClick: ($event: any) => (changeItem(index, item.id))
            }, _toDisplayString(item.name), 11, _hoisted_15))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _withDirectives(_createElementVNode("span", null, "*", 512), [
            [_vShow, _unref(form).status == '1']
          ])
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "box_list1_club_list_item",
            onClick: uploadFile
          }, _hoisted_21),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form).files, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "box_list1_club_list_item",
              key: index,
              onClick: ($event: any) => (seeBigFile(index))
            }, [
              _createElementVNode("img", {
                class: "close",
                src: _imports_2,
                onClick: _withModifiers(($event: any) => (dele(index)), ["stop"])
              }, null, 8, _hoisted_23),
              (item.type === 1)
                ? (_openBlock(), _createElementBlock("img", _hoisted_24))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_25, [
                (item.type === 1)
                  ? (_openBlock(), _createElementBlock("video", {
                      key: 0,
                      src: item.url
                    }, null, 8, _hoisted_26))
                  : (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "type_img",
                      src: item.url,
                      alt: ""
                    }, null, 8, _hoisted_27))
              ])
            ], 8, _hoisted_22))
          }), 128)),
          _hoisted_28,
          _hoisted_29
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_30, [
      _hoisted_31,
      _withDirectives(_createElementVNode("textarea", {
        name: "",
        id: "",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).remarks) = $event)),
        cols: "20",
        rows: "5",
        maxlength: "300",
        placeholder: "请详细描述巡检情况"
      }, null, 512), [
        [_vModelText, _unref(form).remarks]
      ])
    ]),
    _createElementVNode("div", _hoisted_32, [
      _withDirectives((_openBlock(), _createElementBlock("button", {
        class: "box_footer_submit",
        onClick: submit
      }, _hoisted_34)), [
        [_directive_preventReClick]
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _unref(show),
      "onUpdate:show": _cache[2] || (_cache[2] = ($event: any) => (_isRef(show) ? (show).value = $event : show = $event)),
      position: "bottom",
      round: "",
      style: { height: '50%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_search, {
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(value) ? (value).value = $event : value = $event)),
          onBlur: changeValue,
          placeholder: "请输入搜索关键词"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_van_picker, {
          title: "请选择设备",
          columns: _unref(value) ? _unref(data) : _unref(columns),
          onConfirm: onConfirm,
          onCancel: onCancel
        }, null, 8, ["columns"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_van_popup, {
      show: _unref(showTime),
      "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_isRef(showTime) ? (showTime).value = $event : showTime = $event)),
      position: "bottom",
      round: "",
      style: { height: '40%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          modelValue: currentDate.value,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentDate).value = $event)),
          type: "datetime",
          title: "选择完整时间",
          onCancel: closeTime,
          onConfirm: queding,
          "min-date": _unref(minDate),
          "max-date": _unref(maxDate)
        }, null, 8, ["modelValue", "min-date", "max-date"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_v_ScanCode, {
      openCode: _unref(openCodea),
      infos: ['请扫描设备码'],
      onClosePopup: closePopupa,
      onOnDecode: onDecodea
    }, null, 8, ["openCode"]),
    _createElementVNode("input", {
      type: "file",
      hidden: "",
      accept: "video/mp4,image/png,image/jpeg,image/jpg",
      multiple: "",
      onChange: upFile,
      ref_key: "upload",
      ref: upload
    }, null, 544),
    (_unref(isOpen))
      ? (_openBlock(), _createBlock(vPreview, {
          key: 0,
          list: _unref(form).files,
          index: _unref(index),
          onClose: close
        }, null, 8, ["list", "index"]))
      : _createCommentVNode("", true)
  ]))
}
}

})